<template>
  <AppForm label="日本語の端末設定に限る">
    <v-switch
      :false-value="false"
      :input-value="value"
      @click.prevent.stop="switchOnlyJapaneseDevice"
      class="ma-1"
      hide-details
    />
    <span v-if="value" class="red--text">
      言語設定が不明の端末も除外されるため、配信量が減少します。
    </span>
  </AppForm>
</template>

<script>
export default {
  name: 'FormOnlyJapaneseDevice',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    switchOnlyJapaneseDevice() {
      this.$emit('input', !this.value)
    },
  },
}
</script>
